<template>
  <v-container class="pa-0" style="width: auto; height: auto">
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          icon
          v-if="!$store.state.teacherAccess"
          style="width: auto; height: auto"
          v-bind="attrs"
          v-on="on"
          @click="layout = true"
        >
          <my-icon
            :name="'setting-icon'"
            :fill="$vuetify.theme.isDark ? '#fff' : '#000'"
            :width="18"
            :height="18"
            :cursor-pointer="true"
          />
        </v-btn>
      </template>
      <span>{{ $t("template-setting") }}</span>
    </v-tooltip>
    <!--dialog-->
    <v-dialog
      v-model="layout"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn icon color="grey darken-2" class="close-hover" @click="layout = false">
            <v-icon large> mdi-close </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <setting />
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6" />
            <v-col cols="6">
              <v-btn color="grey" outlined class="float-left" @click="layout = false">
                {{ $t("cancel") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Setting from "@/views/dashboard/components/core/Settings.vue";
import MyIcon from "@/views/dashboard/components/general/icon/MyIcon.vue";

export default {
  name: "DashboardCoreAppBar",
  data() {
    return {
      layout: false,
    };
  },
  components: {
    Setting,
    MyIcon,
  },
};
</script>

<style scoped></style>
